import { Card, Divider, Skeleton, message } from "antd"
import ProjectSettingsForm, { IProjectSettingsFormObject } from "pages/settings/components/project-settings-form"
import { useSettings, useUpdateSettings } from "hooks/settings"

const ProjectsSettingsSection = () => {
  const { settings, loading } = useSettings()
  const { updateSettings, loading: updating } = useUpdateSettings()

  if (loading || settings === undefined) return (
    <Card style={{
      width: '400px',
    }}>
      <Skeleton />
    </Card>
  )

  const initialValues: IProjectSettingsFormObject = {
    projectClientManager: settings.projectClientManager as 'admin' | 'member',
    projectDefaults: {
      visibility: settings.projectDefaults?.visibility ?? false,
      clientId: settings.projectDefaults?.clientId ?? null,
      taskCreator: settings.projectDefaults?.taskCreator ?? 'member',
      billableEnabled: settings.projectDefaults?.billableEnabled ?? false,
      defaultIsBillableTimeLogs: settings.projectDefaults?.defaultIsBillableTimeLogs ?? false
    }
  }

  const handleSubmit = async (settings: IProjectSettingsFormObject) => {
    const response = await updateSettings(settings)

    if (response.ok) {
      message.success("Project settings updated!")
    }

    return response
  }

  return (
    <ProjectSettingsForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  )
}

export default ProjectsSettingsSection 